// Pin-set persistence for Saved Filters tabs (Phase 4).
//
// "Pinned" is a UI-only preference for V1 — it lives in localStorage and
// doesn't sync across devices. When the saved_screens table grows a
// per-user "pinned" column we'll migrate; until then this keeps the
// blast radius to the frontend.

const STORAGE_KEY = "pinnedFilterIds";
export const PINNED_MAX = 5;
export const TABS_MAX = 7;

export function readPinnedIds(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((v): v is string => typeof v === "string")
      .slice(0, PINNED_MAX);
  } catch {
    return [];
  }
}

export function writePinnedIds(ids: ReadonlyArray<string>): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(ids.slice(0, PINNED_MAX)),
    );
  } catch {
    // ignore
  }
}

export function togglePinned(
  current: ReadonlyArray<string>,
  id: string,
): string[] {
  if (current.includes(id)) {
    return current.filter((existing) => existing !== id);
  }
  if (current.length >= PINNED_MAX) {
    return [...current];
  }
  return [...current, id];
}
